export default __webpack_public_path__ + "static/media/logo-light.2ae6bd12.svg";